module.exports = __webpack_public_path__ + "static/img/Warsaw_Employer_Branding_2017_14.b656239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/Warsaw_Employer_Branding_2017_14.jpg
// module id = meAW
// module chunks = 0